import { Component } from '@angular/core';
import { FuncsService } from '../services/funcs.service';
import { Customer, CustomerCurrent } from '../data/customer';

@Component({
    selector: 'app-home-reports',
    templateUrl: './admin-home.component.html',
    styleUrls: ['./admin-home.component.css'],
    standalone: false
})
export class AdminHomeComponent {
  constructor(
    private funcs: FuncsService
  ) {}

  fullAdmin = false;

  ngOnInit() {
    this.funcs.checkAdmin();
    this.funcs.currentCustomer(CustomerCurrent);
    if (CustomerCurrent.role === "ADM") {
      this.fullAdmin = true;
    }
  }

  logOut() {
    this.funcs.logOutCustomer();
  }
}
